import { SVGProps } from "react"
const ApartIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M30.6853 11.668H18.6483C15.0372 11.668 13.8335 13.9055 13.8335 16.668V36.668H35.5002V16.668C35.5002 13.9055 34.2965 11.668 30.6853 11.668Z"
      stroke="#6F6F6F"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.8335 36.668H37.1668"
      stroke="#6F6F6F"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.1665 21.668H30.4998"
      stroke="#6F6F6F"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.1665 26.668H30.4998"
      stroke="#6F6F6F"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.1665 16.668H30.4998"
      stroke="#6F6F6F"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.3519 3.33203H10.3148C6.7037 3.33203 5.5 6.31536 5.5 9.9987V36.6654H27.1667V9.9987C27.1667 6.31536 25.963 3.33203 22.3519 3.33203Z"
      fill="white"
      stroke="#6F6F6F"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 21.668H13.8333"
      stroke="#6F6F6F"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.8335 21.668H22.1668"
      stroke="#6F6F6F"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 28.332H13.8333"
      stroke="#6F6F6F"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.8335 28.332H22.1668"
      stroke="#6F6F6F"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 15H13.8333"
      stroke="#6F6F6F"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.8335 15H22.1668"
      stroke="#6F6F6F"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 8.33203H13.8333"
      stroke="#6F6F6F"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.8335 8.33203H22.1668"
      stroke="#6F6F6F"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default ApartIcon
